module.exports = __webpack_public_path__ + "static/media/banner-sports-web.f6ded471.jpg";